class FormSubmit extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const that = this;
    this.onclick = (e) => {
      if (that.hasAttribute("disabled")) {
        return;
      }

      e.preventDefault();
      that.setAttribute("loading", "");
      that.form = that.closest("form");
      const formId = that.form.getAttribute("id");
      const formErrorsTarget = document.querySelector(`#${formId} form-errors`);
      const formSuccess = document.querySelector(`#${formId} form-success`);

      if (!!!formErrorsTarget) {
        console.warn(`Form with ID: ${formId} does not contain a form-errors container. No errors will be shown`);
      }

      fetch(that.form.getAttribute("action"), {
        method: that.form.getAttribute("method"),
        body: new FormData(that.form),
      })
        .then((res) => res.text())
        .then((text) => {
          const htmlResponse = new CustomDOMParser().parseFromString(text);
          if (!!htmlResponse.querySelector('link[rel="canonical"]')) {
            const canonical = htmlResponse.querySelector('link[rel="canonical"]').getAttribute("href");
            if (canonical.includes("/challenge")) {
              console.warn("Disable recaptcha");
              that.removeAttribute("loading");
              return;
            }
          }

          if (!!htmlResponse.querySelector("title")) {
            if (htmlResponse.querySelector("title").innerHTML == "Too many attempts") {
              if (!!formErrorsTarget) {
                formErrorsTarget.innerHTML =
                  '<p class="errors spacing-bottom-m">Te veel pogingen. Probeer het later nog eens.</p>';
                that.form.dispatchEvent(
                  new CustomEvent("form:submit:error", {
                    detail: { error: "Too many attempts", response: htmlResponse },
                  }),
                );
                that.removeAttribute("loading");
                return;
              }
            }
          }
          let formErrors = htmlResponse.querySelector(`#${formId} form-errors`);
          if (!!formErrors) {
            formErrors = formErrors.innerHTML.trim();
          } else {
            formErrors = "";
          }
          if (formErrors != "" && !!formErrorsTarget) {
            formErrorsTarget.innerHTML = formErrors;
            that.form.dispatchEvent(new CustomEvent("form:submit:error", { detail: { error: formErrors } }));
          } else {
            that.form.dispatchEvent(new CustomEvent("form:submit:success", {}));
            if (formErrors == "" && !!formErrorsTarget) {
              formErrorsTarget.innerHTML = "";
            }
            if (!!formSuccess) {
              formSuccess.style.display = "block";
            }
          }
          that.removeAttribute("loading");
        })
        .catch((err) => {
          that.form.dispatchEvent(new CustomEvent("form:submit:error", { detail: { error: err } }));
          that.removeAttribute("loading");
        });
    };
  }
}
customElements.define("form-submit", FormSubmit);
customElements.define("form-errors", class extends HTMLElement {});
customElements.define("form-success", class extends HTMLElement {});
